export default __webpack_public_path__ + "static/closer-1dc3735dcb7a3258ae17b4691c1e9b8b.svg";